import { GoogleMap, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';
import React, { useCallback, useRef } from 'react';
import train5 from '../../../assets/images/train/train5.svg';
import { FETCH_LOCATION_STREET_NAME, MAP_PIN_UPDATED, MAP_ZOOM_UPDATED } from '../ListingActionTypes';
import { useDispatch } from 'react-redux';

const ListingMap = ({ locationDetails, nearLatitude, nearLongitude, country }) => {
  const dispatch = useDispatch();
  const mapRef = useRef(null);

  const handleZoomChanged = () => {
    if (mapRef.current) {
      dispatch({
        type: MAP_ZOOM_UPDATED,
        payload: {
          mapZoom: mapRef.current.getZoom(),
        },
      });
    }
  };

  const onMarkerDragEnds = (event) => {
    dispatch({
      type: MAP_PIN_UPDATED,
      payload: {
        latitude: event.latLng.lat(),
        longitude: event.latLng.lng(),
      },
    });
  };

  const handleMapClick = (event) => {
    dispatch({
      type: MAP_PIN_UPDATED,
      payload: {
        latitude: event.latLng.lat(),
        longitude: event.latLng.lng(),
      },
    });
  };

  const getCountryBounds = (countryName) => {
    switch (countryName?.toLowerCase()) {
      case 'sri-lanka':
      case 'srilanka':
      case 'lk':
        return { north: 9.9, south: 5.9, east: 81.9, west: 79.5 };
      case 'singapore':
      case 'sg':
        return { north: 1.48, south: 1.15, east: 104.1, west: 103.58 };
      case 'australia':
      case 'au':
        return { north: -9.0, south: -44.0, east: 154.0, west: 112.0 };
      default:
        return null;
    }
  };

  const bounds = getCountryBounds(country);
  const mapOptions = { gestureHandling: 'greedy' };
  if (bounds) {
    mapOptions.restriction = { latLngBounds: bounds, strictBounds: false };
  }

  return (
    <GoogleMap
      ref={(map) => {
        mapRef.current = map;
      }}
      defaultZoom={Number(locationDetails?.mapZoom) || 8}
      zoom={Number(locationDetails?.mapZoom) || 8}
      onZoomChanged={handleZoomChanged}
      defaultCenter={{ lat: Number(locationDetails?.latitude), lng: Number(locationDetails?.longitude) }}
      center={{ lat: Number(locationDetails?.latitude), lng: Number(locationDetails?.longitude) }}
      onClick={handleMapClick}
      options={mapOptions}
    >
      <Marker
        position={{ lat: Number(locationDetails?.latitude), lng: Number(locationDetails?.longitude) }}
        draggable={true}
        onDragEnd={onMarkerDragEnds}
      />
      {nearLatitude && nearLongitude ? (
        <Marker
          position={{ lat: Number(nearLatitude), lng: Number(nearLongitude) }}
          icon={{ url: train5, scaledSize: { height: 30, width: 30 } }}
        />
      ) : null}
    </GoogleMap>
  );
};

export default withScriptjs(withGoogleMap(ListingMap));
